import { TextField } from "@mui/material"

export default function Rpps({value, onChange, required, disabled, error, size}){

    const handleChange = e => {
        let v = e.target.value.replace(/\D/g,'');
        return onChange(v);
    }

    const helperText = error ? "Ce numéro RPPS n'est pas valide" :
        "Identifiant à 11 chiffres du professionnel de santé. Ex. : 10101341427";

    return <TextField
        label='Numéro RPPS'
        value={value || ''}
        onChange={handleChange}
        inputProps={{
            pattern: "[0-9]{11}", 
            minLength: 11, 
            maxLength: 11
        }}
        size={size || 'small'}
        helperText={helperText}
        required={required ? true : false}
        disabled={disabled ? true : false}
        error={error}
    />
}